import { Button, LinkButton, Text, WorkspaceLogo } from '@sketch/components'
import { breakpoint } from '@sketch/global-styles'
import { IndexLayoutOld } from '@sketch/modules-common'
import { Main } from '@sketch/modules-common/src/components/IndexLayoutOld/IndexLayout.styles'

import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 448px;

  padding: 32px;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.background.secondary.A};
  border-radius: ${({ theme }) => theme.radii.large};

  box-shadow: ${({ theme }) => theme.shadows.boxShadow.panel};

  ${breakpoint('base', 'sm')`
    width: 100%;
  `}
`

export const StyledWorkspaceLogo = styled(WorkspaceLogo)`
  margin-bottom: 14px; /* stylelint-disable-line scales/space */
`

export const SwitchAccount = styled(Button)`
  margin-top: 16px;
`

export const BackButton = styled(LinkButton)`
  && {
    margin-top: 16px;
    margin-left: 0;
  }
`

export const Description = styled(Text)`
  margin-top: 16px;
`

export const BottomText = styled(Text)`
  margin: 24px auto 0;
  text-align: center;
`

export const ErrorWrapper = styled.div`
  display: flex;
`

export const StyledIndexLayoutOld = styled(IndexLayoutOld)`
  ${Main} {
    flex: 1;
    display: flex;
  }
`
